let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { MAIN_SECTION_MAX_WIDTH } from '../../layout/constants';
export const MarketingNavGlobalStyle = createGlobalStyle(_t || (_t = _`
  .hsg-page-width-normal,
  .hs-page-width-normal {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0} !important;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--cta {
    @media (min-width: 768px) {
      padding-right: 0;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--search {
    display: none;
  }

  .hsg-nav__group-item > #hsg-nav__logo > #hsg-nav__logo-mobile {
    display: none;
  }

  .hsg-footer__layout {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0}px !important;
    }
  }
`), MAIN_SECTION_MAX_WIDTH, ({
  theme
}) => theme.space['1100'], MAIN_SECTION_MAX_WIDTH, ({
  theme
}) => theme.space['1100']);